import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Importing global styles
import './i18n/config'; // Initialize i18n
import App from './App';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { LanguageProvider } from './contexts/LanguageContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </Router>
  </Provider>
);
